import React from "react";
import { P_Props } from "./BannerForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../../../utils";
import { ImageUpload, Loading, SimpleModalHeader, CategoryCard1 } from "../../../../components";
import { Grid, TextField, Switch, FormControlLabel, Select, MenuItem } from "@material-ui/core";
import { FORM_MODE, BannerOutputModel } from "../../../../../models";
import { CustomColorPicker } from "../../../../components/index";

const BannerFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const bindindBannerDataToForm = (data: BannerOutputModel[]) => {
    const transfomedData = data.reduce((result, item) => {
      return {
        ...result,
        ...item,
        [`title${item.languageId}`]: item.title,
        [`shortDescription${item.languageId}`]: item.shortDescription,
      };
    }, {});
    return transfomedData;
  };

  return (
    <>
      <div className="banner-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New Banner" : "Banner Detail"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="banner-form__divide">
          <div className="banner-form__language">
            <h1>Language</h1>
            {props.languageData.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  picture={lang.image || undefined}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  onClick={() => {
                    props.onChangeLanguage(lang.id);
                  }}
                  selected={props.activeLanguageId === lang.id}
                  isAvatar={true}
                />
              );
            })}
          </div>

          <div className="banner-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={props.initData?.length ? bindindBannerDataToForm(props.initData) : {}}
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          {FormUIUtil.renderFormItem(
                            "Status",
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={props.bannerStatus.status}
                                  onChange={(e) => {
                                    props.onChangeBannerStatus(e.target.checked);
                                  }}
                                  className="app-switch-box"
                                />
                              }
                              label={
                                <div className="form-label" style={{ marginBottom: 0 }}>
                                  Publish
                                </div>
                              }
                            />,
                            true
                          )}
                        </Grid>
                        <Grid item xs={10}>
                          {props.languageData.map((lang) => {
                            return (
                              <div
                                key={lang.id}
                                style={{ display: props.activeLanguageId === lang.id ? "flex" : "none" }}
                              >
                                <Field
                                  name={`title${lang.id}`}
                                  validate={lang.isPrimary ? FormUtil.Rule.required("Title is required") : undefined}
                                  subscription={{ touched: true, error: true, value: true }}
                                >
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Banner title",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        placeholder="Add title"
                                        className="form-text-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => {
                                          input.onChange(e.target.value);
                                        }}
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                      />,
                                      true
                                    );
                                  }}
                                </Field>
                              </div>
                            );
                          })}
                        </Grid>
                        <Grid item xs={2}>
                          {FormUIUtil.renderFormItem(
                            "Color title",
                            <div className="input__color-picker" onClick={() => props.handleClickColor()}>
                              <div
                                className="input__color-picker-tag"
                                style={{ backgroundColor: props.currentColor }}
                              />
                              <div style={{ margin: "0 1rem" }}>&#x25BC;</div>
                              <CustomColorPicker
                                className="input__color-picker--template"
                                disableOnClickOutside={false}
                                displayColorPicker={props.displayColorPicker}
                                currentColor={props.currentColor}
                                handleChangeColor={(color) => props.handleChangeColor(color)}
                                handleClosePicker={() => props.handleClosePicker()}
                                handleClickColor={() => props.handleClickColor()}
                              />
                            </div>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          {props.languageData.map((lang) => {
                            return (
                              <div
                                key={lang.id}
                                style={{
                                  display: props.activeLanguageId === lang.id ? "flex" : "none",
                                }}
                              >
                                <Field name={`shortDescription${lang.id}`}>
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      `Description`,
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        placeholder="Input description"
                                        className="form-textarea-field"
                                        inputProps={{ className: "input", maxLength: 150 }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            );
                          })}
                        </Grid>
                        <Grid item xs={12}>
                          <Field name="Position">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Position",
                                <Select
                                  {...input}
                                  {...rest}
                                  // native
                                  value="Homepage slider"
                                  error={meta.error && meta.touched}
                                  fullWidth
                                  variant="outlined"
                                  className="form-select-field"
                                  disabled
                                >
                                  <MenuItem value="Homepage slider">Homepage slider</MenuItem>
                                </Select>,
                                true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12}>
                          {FormUIUtil.renderFormItem(
                            "Upload images",
                            <>
                              <ImageUpload
                                className="banner-form__avatar"
                                fileList={props.bannerPictures}
                                max={1}
                                onChange={props.onUploadBanner}
                                onDelete={props.onRemoveBanner}
                                config={{ uploadModal: true }}
                              />
                              <p className="banner-form__avatar--note">
                                The image dimension required 1440x432px. JPG, PNG or GIF are allowed
                              </p>
                            </>, false, true
                          )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                          {FormUIUtil.renderFormItem(
                            "Upload an image for Responsive Website",
                            <>
                              <ImageUpload
                                className="banner-form__avatar"
                                fileList={props.bannerResponsivePictures}
                                max={1}
                                onChange={props.onUploadResponsiveBanner}
                                onDelete={props.onRemoveResponsiveBanner}
                                config={{ uploadModal: true }}
                              />
                              <p className="banner-form__avatar--note">Recommended size of the image is below 1 MB</p>
                            </>, false, true
                          )}
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="banner-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            {props.mode === FORM_MODE.CREATE ? "Create" : "Save"}
          </button>
        </div>
      </div>
    </>
  );
};

export default BannerFormPresenter;
